import Admin from "../Admin";
import React from "react";
import CardAdminPermissionList from "../../../Component/Card/Admin/Permission/CardAdminPermissionList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class AdminPermissionList extends Admin {
  renderContent() {
    return <CardAdminPermissionList />;
  }

  renderHeader() {
    const handleClickCreate = () => {
      this.props.history.push({
        pathname: "/admin/permission",
      });
    };

    const buttons = [
      <MUIButton
        component="label"
        variant="contained"
        startIcon={<MUIAddIcon />}
        onClick={handleClickCreate}
      >
        Create New
      </MUIButton>,
    ];

    return <PageHeader title="Permissions" buttons={buttons} />;
  }
}
